import { PAReviewModule } from "@/store/modules/paReview.module";
import { assign, Machine } from "xstate";
import { toaster } from "@/utilities/toaster";
const clientInteractionMachine = Machine({
    id: "clientInteractionMachine",
    context: {
        cycleId: "",
        stepId: "",
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_REVIEWS: { target: "gettingReviews", actions: "assignCycleIdAndStepId" },
            },
        },
        gettingReviews: {
            invoke: {
                id: "gettingReviews",
                src: (context, event) => {
                    return PAReviewModule.ClientInteractionDetails({ cycleId: context.cycleId, stepId: context.stepId });
                },
                onDone: { target: "loadedReviews" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedReviews: {
            on: {
                SAVE_ASSIGNMENTS: { target: "savingAssignments" },
                SEND_NUDGE_MAIL: { target: "sendingNudgeMail" },
                REVIEW_MODAL_CLOSING: { target: "gettingReviews" },
                UPDATING_AUTO_NUDGE: { target: "updateAutoNudge" },
            },
        },
        savingAssignments: {
            invoke: {
                id: "savingAssignments",
                src: (context, event) => {
                    return PAReviewModule.SaveClientAssignments({ assignments: event.assignments, customizedContent: event.customizedContent });
                },
                onDone: { target: "gettingReviews", actions: "showSuccessMessage" },
                onError: { target: "serviceUnavailable" },
            },
        },
        sendingNudgeMail: {
            invoke: {
                id: "sendingNudgeMail",
                src: (context, event) => {
                    return PAReviewModule.ClientNudgeEmail(event.assignment);
                },
                onDone: { target: "gettingReviews", actions: "showSuccessMessage" },
                onError: { target: "serviceUnavailable" },
            },
        },
        updateAutoNudge: {
            invoke: {
                id: "updateAutoNudge",
                src: (context, event) => {
                    return PAReviewModule.UpdateAutoNudgeForClientContact({ cycleId: context.cycleId, autoNudge: event.autoNudge, contactId: event.contactId });
                },
                onDone: { target: "loadedReviews" },
                onError: { target: "serviceUnavailable" },
            },
        },
        serviceUnavailable: { type: "final" },
    },
}, {
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 5000);
        }),
    },
    actions: {
        showSuccessMessage: (coontext, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignCycleIdAndStepId: assign({
            cycleId: (context, event) => event.cycleId,
            stepId: (context, event) => event.stepId,
        }),
    },
    guards: {},
    activities: {},
});
export default clientInteractionMachine;
